import { useContentsContext } from "./useContentsContext.hook";
import { CONTENTS_URL_v2 } from "../../../crud/helpers/routes";
import {
  getMultipartParams,
  handleResponse,
} from "../../../crud/helpers/validate";
import notice from "../../../utils/notice";
import { contentApapter } from "../adapters/content.adapter";
import { setLoader } from "../../../../redux/ducks/load.duck";
import { useDispatch } from "react-redux";

export const useContents = () => {
  const {
    isProAthleteContent,
    page,
    setContentsList,
    setContent,
    zoneId,
    query,
    resetValues_ContentsList,
  } = useContentsContext();
  const dispatch = useDispatch();

  const getContentsx = async () => {
    dispatch(setLoader(true));

    try {
      resetValues_ContentsList();
      let url = `list-category?category_id=${zoneId}&page=${page}&search_query=${query}&is_pro_athlete=${isProAthleteContent}&per_page=500`;
      // if (!!focus_area && focus_area !== 0) {
      //   url = `list-category?category_id=${zoneId}&focus_area_id=${focus_area}&page=${page}&search_query=${query}&is_pro_athlete=${pro_athlete}&per_page=500`;
      // }

      const res = await fetch(
        `${CONTENTS_URL_v2}/${url}`,
        getMultipartParams("GET")
      );
      const json = await handleResponse(res); // asumo que esto puede lanzar o devolver json
      setContentsList(json);
      return json;
    } catch (error) {
      notice("Error on loading contents ");
      console.error(error.errors);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const getContentx = async (id) => {
    try {
      const res = await fetch(
        `${CONTENTS_URL_v2}/show?id=${id}`,
        getMultipartParams("GET")
      );
      const json = await handleResponse(res); // asumo que esto puede lanzar o devolver json
      const newValue = contentApapter(json);
      setContent(newValue);
      return newValue;
    } catch (err) {
      notice("Error on loading content ");
      console.error(err?.errors ?? err);
    }
  };

  const create = async (data) => {
    try {
      const formData = _generateFormData(data);
      const res = await fetch(
        `${CONTENTS_URL_v2}/create-content`,
        getMultipartParams("POST", formData)
      );
      // eslint-disable-next-line no-unused-vars
      const _json = await handleResponse(res);
      notice("Content created", "success");
    } catch (e) {
      notice("Error saving the content");
      console.log(e);
    }
  };

  const update = async (data, id) => {
    try {
      const formData = _generateFormData(data);
      const res = await fetch(
        `${CONTENTS_URL_v2}/update?id=${id}`,
        getMultipartParams("PUT", formData)
      );
      const json = await handleResponse(res);
      if (json && json.id) {
        notice("Content  updated", "success");
      } else {
        notice("Error saving the content");
      }
    } catch (e) {
      notice("Error saving the content");
      console.error(e);
    }
  };

  const _generateFormData = (data) => {
    const formData = new FormData();
    for (const name in data) {
      if (Array.isArray(data.content) && name === "content") continue;
      formData.append(name, data[name]);
    }
    if (Array.isArray(data.content)) {
      for (const index in data.content) {
        formData.append("content" + index, data.content[index]);
      }
      formData.append("totalContents", data.content.length);
    }
    return formData;
  };

  return { getContentsx, getContentx, create, update };
};
